import { useAuth } from "@tellescope/tanstack-query";
import { useMemo } from "react";

/**
 * Get a label for a phone number if one exists in org settings.
 *
 * @param phoneNumber - The phone number to get a label for
 * @returns The label if found, or the phone number itself
 */
export function usePhoneNumberLabel() {
  const { selectedOrganization: organization } = useAuth();

  return useMemo(() => {
    const labelMap = new Map<string, string>();
    organization?.phoneLabels?.forEach(({ number, label }) => {
      labelMap.set(number, label);
    });

    return (phoneNumber: string): string => {
      return labelMap.get(phoneNumber) || phoneNumber;
    };
  }, [organization?.phoneLabels]);
}
